import React from 'react';
import styled from 'styled-components';

const CircleContainer = styled.div`
  position: relative;
  width: 150px;
  height: 100px;
  background-color: black;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const NeonLights = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border: 2px solid #0ff;
  border-radius: 50%;
  box-shadow: 0 0 20px #0ff, 0 0 40px #0ff, 0 0 60px #0ff, 0 0 80px #0ff;
  animation: rotateNeon 5s linear infinite;
`;

const Logo = styled.div`
  position: relative;
  z-index: 10;
  font-size: 1.5rem;
  color: white;
`;

const NeonCircle = () => {
  return (
    <CircleContainer>
      <NeonLights />
      <Logo>LOGO</Logo>
    </CircleContainer>
  );
};

export default NeonCircle;
